import React from 'react';

import Footer from './Footer';

import { asset } from 'Services/BaseHelpers';
import PushNotifications from "Components/Partials/PushNotifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export default ({ children }) => (
    <div className="min-h-screen lg:w-full bg-app-purple bg-cover overflow-hidden">
        <nav className="w-full bg-white py-2 flex justify-between">
            <div className="w-full xl:w-full">
                <Link className="w-32 block mx-auto" to="/">
                    <img src={asset('/images/logo.png')} alt="Speedo" className="w-36 mx-auto" />
                </Link>
            </div>
        </nav>

        <div className=" lg:flex bg-app-purple">

            <div className={
                'w-0 lg:w-1/2  bg-blue flex items-end ' +
                'justify-center md:items-center md:justify-end overflow-y-visible'
            }>
                <div className={
                    'w-full invisible  md:visible relative z-10 w-0 md:w-full mx-auto   h-full'
                }>
                    <div className="flex  h-full overflow-hidden w-full">
                        <img alt="" src={asset('/images/login.jpg')} className="hidden lg:block w-full overflow-hidden" />
                    </div>
                </div>

                <img src={asset('/images/logo.png')} alt="Speedo" className="w-full mx-auto md:hidden py-5" />
            </div>

            <div className="w-full lg:w-1/2 md:h-full w-full flex pt-8 md:pt-28 md:mt-0 md:overflow-y-auto">
                <div className="my-auto w-full p-4 lg:p-32 ">
                    <img src={asset('/images/logo.png')} alt="Speedo" className="mb-20 mx-auto hidden md:block" />

                    {children}
                </div>
            </div>
        </div>

        <Footer />
    </div>
);
